export default __webpack_public_path__ + "static/automotive-workflow-solutions-3f24f66b5bc65f0445322941e735b8c7.jpg";